import { render, staticRenderFns } from "./AddRule.vue?vue&type=template&id=72d8455d&scoped=true"
import script from "./AddRule.vue?vue&type=script&lang=js"
export * from "./AddRule.vue?vue&type=script&lang=js"
import style0 from "./AddRule.vue?vue&type=style&index=0&id=72d8455d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d8455d",
  null
  
)

export default component.exports